import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeliveryNoteListComponent } from './deliverynote-list.component';

@Component({
    selector: 'convfact-deliverynotepublish-selected',
    templateUrl: './deliverynote-dialog-publish-selected.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})
export class DeliveryNoteDialogPublishSelectedComponent {

    facturaDesign = 0;

    constructor(
        public dialogRef: MatDialogRef<DeliveryNoteListComponent>,
        public snackBar: MatSnackBar,
    ) { }


    closeDialog() {
        this.dialogRef.close(this.facturaDesign);
    }

}
